import { Spinner } from '@leagueplatform/genesis-core';
import { LeagueConfig } from '@leagueplatform/config';
import { createReactRouterAdapter } from '@leagueplatform/react-router-adapter';
import { legacyStrings } from '@leagueplatform/legacy-locales';
import { customerSupportAppLocales } from '@leagueplatform/cse-customer-support';
import { EN_STRING_OVERRIDES } from 'tenant-configs/locales/highmark-string-overrides/en';
import { theme } from '../theme';

const {
  VITE_HIGHMARK_WS_API_URL,
  VITE_HIGHMARK_API_URL,
  VITE_HIGHMARK_LEGACY_REST_API_URL,
  VITE_ENV,
} = import.meta.env;

export const highmarkConfigFlags = {
  customerSupport: {
    enableActivityOverride: true,
    enableJourneyInquiry: true,
    enableWalletInquiry: true,
    enableClaimsInquiry: true,
    enableMemberOverview: true,
    enableAssessmentsAndDashboards: true,
    enablePageHeaderBanner: true,
    enableBiometricsV2: true,
    faqLink:
      'https://highmrk.saas.verinthms.com/GTConnect/UnifiedAcceptor/FrameworkDesktop.Main',
    claimsInquiry: {
      featureFlags: {
        shouldShowClaimDetails: true,
        shouldShowDownloadClaims: true,
        shouldShowFilterChips: true,
      },
      showClaimStatusDefinitions: true,
    },
    impersonation: {
      enableImpersonateButton: true,
      impersonationRedirectUrl:
        'http://sdk-presenter.league.dev/impersonate?tenant=reference&connection=SupportAgent-DB',
    },
  },
};

export const highmarkCommonCoreConfig = {
  appEnvironment: VITE_ENV,
  api: {
    wsUrl: VITE_HIGHMARK_WS_API_URL,
    url: VITE_HIGHMARK_API_URL,
    legacyRestApi: VITE_HIGHMARK_LEGACY_REST_API_URL,
  },
  analytics: {
    segmentKey: 'HGr7PK6lxQ8wWZNFBw8Ya4fM8dbLl8jp',
  },
  routing: {
    isUsingLeagueRouting: true,
    adapter: createReactRouterAdapter(),
  },
  ui: {
    theme,
    components: {
      loading: { element: <Spinner loading />, text: false },
      pageHeader: {
        shape: 'line',
        backgroundColor: 'surface.background.secondary',
      },
    },
  },
  i18n: {
    stringOverrides: {
      default: EN_STRING_OVERRIDES,
      en: EN_STRING_OVERRIDES,
    },
    strings: { ...legacyStrings, ...customerSupportAppLocales },
  },
} satisfies Partial<LeagueConfig['core']>;
